import { getGridStringOperators, GridFilterInputValueProps, GridFilterOperator } from '@mui/x-data-grid'
import { ComponentType } from 'react'
import { SupportedFilterItemOperator } from '@omnea-app/packages/universal/tables/gridModel'

type OperatorConfig = {
  operators: SupportedFilterItemOperator[]
  InputComponent?: ComponentType<GridFilterInputValueProps> | null
}

export const buildFilterOperators = (configs: OperatorConfig[]): GridFilterOperator[] => {
  const configsWithSets = configs.map((config) => ({ ...config, operators: new Set(config.operators) }))
  return getGridStringOperators().reduce<GridFilterOperator[]>((acc, operator) => {
    for (const config of configsWithSets) {
      if (config.operators.has(operator.value as SupportedFilterItemOperator)) {
        return [
          ...acc,
          {
            ...operator,
            // null = no input component, undefined = use MUI default
            ...(config.InputComponent !== undefined && { InputComponent: config.InputComponent ?? undefined }),
          },
        ]
      }
    }
    return acc
  }, [])
}
